export const CATEGORIES = 'CATEGORIES';
export const CATEGORY = 'CATEGORY';
export const FILTERED = 'FILTERED';
export const MY_TOPICS = 'MY_TOPICS';
export const OTHER_TOPICS = 'OTHER_TOPICS';
export const SUGGESTED_TOPICS = 'SUGGESTED_TOPICS';
export const SUPER_CATEGORIES = 'SUPER_CATEGORIES';
export const SUPER_CATEGORY = 'SUPER_CATEGORY';
